import Box from "@/common/components/Box";
import Modal from "@/common/components/Modal";
import { ArrowRightIcon } from "lucide-react";

export interface AuctionDatesChange {
  label: string;
  before: string;
  after: string;
}

interface ConfirmUpdateAuctionDatesProps {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  changes: AuctionDatesChange[];
  isLoading?: boolean;
  onConfirm: () => void;
}

const ConfirmUpdateAuctionDates = ({
  isOpen,
  setIsOpen,
  changes,
  isLoading,
  onConfirm,
}: ConfirmUpdateAuctionDatesProps) => {
  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Confirmar alteração de datas"
      titleClass="text-2xl"
      bodyClassName="text-white-800"
      useCancellableFooter
      confirmButtonText="Confirmar alteração"
      confirmButtonClassName="bg-blue-700 rounded-br-lg"
      cancelButtonClassName="bg-white-200 rounded-bl-lg"
      confirmButtonIsLoading={isLoading}
      onConfirm={onConfirm}
      body={(
        <div className="flex flex-col gap-4">
          <p className="text-sm text-white-400">
            Revise as alterações antes de aplicar:
          </p>

          <Box className="flex flex-col gap-3 p-4 rounded-md bg-white-200 border border-white-300">
            {changes.map((change) => (
              <div
                key={change.label}
                className="flex flex-col gap-1 border-b border-white-300 pb-3 last:border-b-0 last:pb-0"
              >
                <p className="text-sm font-bold text-white-800">
                  {change.label}
                </p>

                <div className="flex items-center gap-3 text-sm flex-wrap">
                  <span className="text-white-400 line-through">
                    {change.before}
                  </span>

                  <ArrowRightIcon
                    size={16}
                    strokeWidth={1.5}
                    className="text-white-400 shrink-0"
                  />

                  <span className="font-bold text-success-tertiary">
                    {change.after}
                  </span>
                </div>
              </div>
            ))}
          </Box>

          <p className="text-sm font-bold text-white-800">
            Tem certeza que deseja aplicar essas alterações?
          </p>
        </div>
      )}
    />
  );
}

export default ConfirmUpdateAuctionDates;
